const translations = {
  en: {
    appName: 'MAP GO — National GO Registry',
    subtitle: 'Guarantees of Origin — National Registry',
    home: 'Home',
    reports: 'Reports',
    plants: 'Plants',
    market: 'Market',
    users: 'Users',
    approvals: 'Approvals',
    certificates: 'Certificates',
    audit: 'Registry Audit',
    dashboard: 'Dashboard',
    accounts: 'Accounts',
    devices: 'Devices',
    transfers: 'Transfers',
    landingCTA: 'Get started',
    landing_hero_before: 'National',
    landing_hero_highlight: 'Trust',
    landing_hero_after: 'Infrastructure',
    landing_hero_subtitle: 'MAP GO is the primary issuance and tracking infrastructure for Guarantees of Origin. Engineered for strict regulatory compliance and AIB International Hub interoperability.',
    landing_enter_registry: 'Enter Registry',
    landing_register_account: 'Register Account',
    landing_registry_alt: 'Registry Interface',
    landing_stat_volume: 'Domain volume',
    landing_stat_plants: 'Certified Facilities',
    landing_stat_participants: 'Market Participants',
    landing_unit_plants: 'Plants',
    landing_unit_entities: 'Entities',
    landing_protocol_badge: 'Standardized Protocol',
    landing_governance_title: 'Governance Framework',
    landing_eecs_subtitle: 'European Energy Certificate System (EECS) Standards Compliance',
    landing_feat_provenance_title: 'Immutable Provenance',
    landing_feat_provenance_desc: 'Every MWh is tracked from generation to consumption using GS1 standardized range identifiers, ensuring 0% risk of double-counting.',
    landing_feat_interop_title: 'Interoperability',
    landing_feat_interop_desc: 'Full alignment with the AIB Hub Fact Sheets (04/05/16) for automated cross-border certificate transfers.',
    landing_feat_liquidity_title: 'Liquidity Infrastructure',
    landing_feat_liquidity_desc: 'Enabling high-frequency trading and bulk cancellations with automated bilingual attestation generation.',
    landing_feat_oversight_title: 'Regulatory Oversight',
    landing_feat_oversight_desc: 'Complete audit trails for competent authorities, ensuring transparency in national energy mix disclosures.',
    landing_wikihow_link: 'Public Knowledge Base (WikiHow)',
    landing_copyright: 'All Rights Reserved.',
    register: 'Register',
    kyc: 'KYC / Registration',
    login: 'Log In',
    auth_title: 'MAP GO Access',
    auth_subtitle: 'European Energy Certificate System (EECS)',
    email_label: 'EECS Email / Registry ID',
    pass_label: 'Access Passphrase',
    btn_auth: 'Authenticate to Registry',

    // Moroccan Specific (Regulator)
    status_pending_issuance: 'Pending Minting',
    status_issued: 'Issued',
    usage_self_consumption: 'Self-Consumption',
    usage_grid_injected: 'Grid Sales',
    law_82_21: 'Law 82-21 (Autoprod)',
    law_13_09: 'Law 13-09 (Export)',
    h2_ready: 'Green Hydrogen Ready',
    h2_offre_maroc: 'Offre Maroc Project',
    grid_operator: 'Grid Operator (DSO)',
    verified_by: 'Verified by',
    administrative_minting: 'Sovereign Minting',
    independent_auditor: 'Independent Auditor (VVB)',
    direct_line: 'Direct Export Line',
    expiry_red_ii: 'Expiry (RED II)',
    full_disclosure: 'Full Disclosure',
    trading_limit: 'Trading Limit',
    comp_profile: 'Company Profile',
    nav_metering: 'Metering Portal',
    sov_node: 'Initializing Sovereign Node...',
    nat_volume: 'National Volume',
    ent_reg: 'Entities Registered',
    qual_assets: 'Qualified Assets',
    hub_status: 'EECS Hub Status',
    gen_report: 'Generate National Report',
    audit_fingerprint: 'System Audit Fingerprint',
    hash_verified: 'Hash-Verified',
    action_col: 'Action',
    entity_col: 'Entity ID',
    time_col: 'Timestamp',
    integrity_col: 'Integrity',
    wallet_empty: 'Wallet Ledger Empty.',
    recent_logs: 'Recent Certificate Logs',
    view_full: 'View Full Ledger →',
    mint_go: 'Mint GO',
    qualify_entity: 'Qualify Entity',
    reject: 'Reject',
    review_details: 'Review Details',
    is_request: 'Issuance Request',
    approval_queue: 'Registry Approval Queue',
    issuing_body_oversight: 'Issuing Body Oversight: MTEDD Morocco',
    kyc_review: 'KYC Review',
    comp_onboarding: 'Company Onboarding',
    grid_operator_verif: 'Entity Verification Node: ONEE/DSO Group',
    metering_portal: 'Metering Portal',
    readings_pending: 'Readings Pending',
    compliance_score: 'Compliance Score',
    grid_tied_assets: 'Current Grid-Tied Assets',
    manage_all: 'Manage All Assets',
    asset_name: 'Asset Name',
    law_flag: 'Law Flag',
    city_col: 'City',
    actions_col: 'Actions',
    verify_readings: 'Verify Readings',
    decrypting_wallet: 'Decrypting Wallet Ledger...',
    total_mwh_portfolio: 'Total MWh Portfolio',
    compliance: 'Compliance',
    red_ii_export: 'RED II Portfolio Export',
    gs1_col: 'GS1 GIAI Identifier',
    status_col: 'Status',
    volume_col: 'Volume',
    issuance_col: 'Issuance',
    notifs: 'Notifications',
    mark_read: 'Mark all read',
    alert_sync: 'Synchronizing alerts...',
    no_alerts: 'No active alerts',
    view_history: 'View all history',
    select_region: 'Select Region',
    lang_en: 'English',
    lang_fr: 'Français',
    help_hub: 'Knowledge Hub',
    req_issuance: 'Request Issuance',
    wallet_empty_desc: 'No digital certificates found in the current account ledger.',
    first_req: 'Submit your first issuance request →',
    transfer_btn: 'Transfer',
    cancel_btn: 'Cancel',
    awaiting_mtedd: 'Awaiting MTEDD Approval',
    queue_empty: 'Registry Approval Queue is Empty',
    verified: 'Verified',
    audit_trail: 'Audit Trail',
    audit_action: 'Action',
    audit_entity: 'Entity',
    audit_actor: 'Actor',
    audit_timestamp: 'Timestamp',
    audit_details: 'Details',
    audit_old_state: 'Initial State (Old)',
    audit_new_state: 'Post-Action State (New)',
    audit_empty: 'Registry ledger is currently empty.',
    audit_error: 'Failed to retrieve secure logs.',
    audit_standard: 'AIB Global Audit Standard',
    audit_desc: 'This Audit Trail enforces compliance with EECS Rules Section I. Each transition in the certificate lifecycle (Registration → Issuance → Transfer → Cancellation) is recorded here with a SHA-256 hash.',
    close_entry: 'Close Entry',
    compliance_reporting: 'Compliance Reporting',
    compliance_reporting_desc: 'Official registry extracts and regulatory disclosure statements for international domain oversight.',
    market_volume_report: 'Market Volume Report',
    market_volume_desc: 'Global summary of issued, transferred, and cancelled certificates across the domain.',
    account_statement: 'Account Statement',
    account_statement_desc: 'Technical breakdown of certificate wallet holdings and participant transaction history.',
    disclosure_proof: 'Disclosure Proof',
    disclosure_proof_desc: 'EECS compliant cancellation statements for official green power disclosure claims.',
    custom_audit_manifest: 'Custom Audit Manifest',
    custom_audit_desc: 'Initialize raw data export for authorized regulatory inspection.',
    init_wizard: 'Initialize Wizard',
    wizard_title: 'Industrial Report Wizard',
    wizard_failed: 'Wizard generation failed.',
    export_failed: 'Industrial Export Failed: Infrastructure timeout or authorization mismatch.',
    download_pdf: 'Download PDF Extract',
    start_date: 'Start Date',
    end_date: 'End Date',
    generate_extract: 'Generate Bespoke Extract',
    production_plants: 'Production Plants',
    clear_sorts: 'Clear all sortings',
    refresh_grid: 'Refresh grid',
    register_device: 'Register production device',
    search_plants: 'Search plants...',
    dev_name: 'Name',
    dev_locked: 'Locked',
    dev_energy_source: 'Energy Source',
    dev_technology: 'Technology',
    dev_grid_ref: 'Grid Reference',
    dev_owner: 'Owner / Registrant',
    dev_active: 'Active',
    national_grid: 'National Grid',
    no_devices: 'No production devices found in the selected domain.',
    of: 'of',
    items: 'items',
    items_per_page: 'Items per page',
    transfers_ledger: 'Transfers Ledger',
    months: 'Months',
    start_transfer: 'Start Transfer',
    market_liquidity: 'Market Liquidity',
    transactions: 'Transactions',
    transaction_id: 'Transaction ID',
    recipient_entity: 'Recipient Entity',
    domain_col: 'Domain',
    eecs_hub_status: 'EECS Hub Status',
    no_transactions: 'No transaction history recorded.',
    registry_participants: 'Registry Participants',
    registry_participants_desc: 'Lifecycle management for International Issuers & Traders',
    search_participants: 'Search Participants...',
    new_entity: 'New Entity',
    member_id: 'Member ID',
    legal_name: 'Legal Name',
    classification: 'Classification',
    vat_id: 'VAT ID',
    operation_col: 'Operation',
    no_participants: 'No Participants Found',
    no_participants_desc: 'No registry accounts match your search.',
    activate: 'Activate',
    vat_number: 'VAT Number',
    legal_rep: 'Legal Representative',
    registry_id: 'Registry ID',
    reg_country: 'Registration Country',
    confirm_approve: 'Verify and approve this account holder for international GO trading?',
    approve_failed: 'Failed to approve account.',
    action_col: 'Type',
    entity_col: 'Entity',
    time_col: 'Submission Date',
    wiki_back_to_portal: 'Back to Portal',
    wiki_regulatory_cell: 'MTEDD Regulatory Cell'
  },
  fr: {
    appName: 'MAP GO — Registre national des GO',
    subtitle: "Certificats d'Origine — Registre national",
    home: 'Accueil',
    reports: 'Rapports',
    plants: 'Installations',
    market: 'Marché',
    users: 'Utilisateurs',
    approvals: 'Approbations',
    certificates: 'Certificats',
    audit: 'Audit du Registre',
    dashboard: 'Tableau de bord',
    accounts: 'Comptes',
    devices: 'Installations',
    transfers: 'Transferts',
    landingCTA: 'Commencer',
    landing_hero_before: 'Infrastructure Nationale de la',
    landing_hero_highlight: 'Confiance',
    landing_hero_after: '',
    landing_hero_subtitle: 'MAP GO est l\'infrastructure nationale d\'émission et de suivi des Garanties d\'Origine. Conçue pour une conformité réglementaire stricte et l\'interopérabilité avec le Hub International AIB.',
    landing_enter_registry: 'Accéder au Registre',
    landing_register_account: 'Créer un Compte',
    landing_registry_alt: 'Interface du Registre',
    landing_stat_volume: 'Volume du domaine',
    landing_stat_plants: 'Installations Certifiées',
    landing_stat_participants: 'Participants au Marché',
    landing_unit_plants: 'Centrales',
    landing_unit_entities: 'Entités',
    landing_protocol_badge: 'Protocole Standardisé',
    landing_governance_title: 'Cadre de Gouvernance',
    landing_eecs_subtitle: 'Conformité aux normes du Système Européen de Certificats Énergétiques (EECS)',
    landing_feat_provenance_title: 'Provenance Immuable',
    landing_feat_provenance_desc: 'Chaque MWh est suivi de la production à la consommation via des identifiants de plage GS1, éliminant tout risque de double comptage.',
    landing_feat_interop_title: 'Interopérabilité',
    landing_feat_interop_desc: 'Alignement complet avec les Fact Sheets du Hub AIB (04/05/16) pour les transferts transfrontaliers automatisés.',
    landing_feat_liquidity_title: 'Infrastructure de Liquidité',
    landing_feat_liquidity_desc: 'Trading à haute fréquence et annulations en masse avec génération automatique d\'attestations bilingues.',
    landing_feat_oversight_title: 'Supervision Réglementaire',
    landing_feat_oversight_desc: 'Pistes d\'audit complètes pour les autorités compétentes, garantissant la transparence du mix énergétique national.',
    landing_wikihow_link: 'Base de Connaissances Publique (WikiHow)',
    landing_copyright: 'Tous droits réservés.',
    register: 'S\u2019inscrire',
    kyc: 'KYC / Enregistrement',
    login: 'Connexion',
    auth_title: 'Accès MAP GO',
    auth_subtitle: 'Système Européen de Certificats Energétiques (EECS)',
    email_label: 'Email EECS / ID Registre',
    pass_label: 'Mot de passe',
    btn_auth: 'Authentification au Registre',

    // Moroccan Specific (Regulator)
    status_pending_issuance: 'En attente de minting',
    status_issued: 'Émis',
    usage_self_consumption: 'Auto-consommation',
    usage_grid_injected: 'Vente au Réseau',
    law_82_21: 'Loi 82-21 (Autoprod)',
    law_13_09: 'Loi 13-09 (Export)',
    h2_ready: 'H2-Prêt (Hydrogène)',
    h2_offre_maroc: 'Projet Offre Maroc',
    grid_operator: 'Opérateur Réseau (DSO)',
    verified_by: 'Vérifié par',
    administrative_minting: 'Minting Régalien',
    independent_auditor: 'Auditeur Indépendant (VVB)',
    direct_line: 'Ligne Directe Export',
    expiry_red_ii: 'Expiration (RED II)',
    full_disclosure: 'Divulgation Totale',
    trading_limit: 'Limite de Transaction',
    comp_profile: 'Profil Entreprise',
    nav_metering: 'Portail de Comptage',
    sov_node: 'Initialisation du Node Régalien...',
    nat_volume: 'Volume National',
    ent_reg: 'Entités Enregistrées',
    qual_assets: 'Actifs Qualifiés',
    hub_status: 'Statut du Hub EECS',
    gen_report: 'Générer le Rapport National',
    audit_fingerprint: "Empreinte de l'Audit Système",
    hash_verified: 'Hash-Vérifié',
    action_col: 'Action',
    entity_col: 'ID Entité',
    time_col: 'Horodatage',
    integrity_col: 'Intégrité',
    wallet_empty: 'Ledge de Wallet vide.',
    recent_logs: 'Journaux de certificats récents',
    view_full: 'Voir le grand livre complet →',
    mint_go: 'Mint GO',
    qualify_entity: 'Qualifier l\'entité',
    reject: 'Rejeter',
    review_details: 'Détails de l\'examen',
    is_request: 'Demande d\'émission',
    approval_queue: "File d'attente d'approbation",
    issuing_body_oversight: 'Supervision de l\'Autorité : MTEDD Maroc',
    kyc_review: 'Examen KYC',
    comp_onboarding: 'Intégration d\'entreprise',
    grid_operator_verif: 'Noeud de vérification d\'entité : Groupe ONEE/DSO',
    metering_portal: 'Portail de Comptage',
    readings_pending: 'Relevés en attente',
    compliance_score: 'Score de Conformité',
    grid_tied_assets: 'Actifs raccordés au réseau',
    manage_all: 'Gérer tous les actifs',
    asset_name: 'Nom de l\'actif',
    law_flag: 'Indicateur de Loi',
    city_col: 'Ville',
    actions_col: 'Actions',
    verify_readings: 'Vérifier les relevés',
    decrypting_wallet: 'Déchiffrement du portefeuille...',
    total_mwh_portfolio: 'Portefeuille Total MWh',
    compliance: 'Conformité',
    red_ii_export: 'Exportation RED II',
    gs1_col: 'Identifiant GS1 GIAI',
    status_col: 'Statut',
    volume_col: 'Volume',
    issuance_col: 'Émission',
    notifs: 'Notifications',
    mark_read: 'Tout marquer comme lu',
    alert_sync: 'Synchronisation des alertes...',
    no_alerts: 'Aucune alerte active',
    view_history: 'Voir tout l\'historique',
    select_region: 'Sélectionner la région',
    lang_en: 'Anglais',
    lang_fr: 'Français',
    help_hub: 'Centre de Connaissance',
    req_issuance: 'Demander l\'Émission',
    wallet_empty_desc: 'Aucun certificat numérique trouvé dans le grand livre du compte actuel.',
    first_req: 'Soumettez votre première demande d\'émission →',
    transfer_btn: 'Transférer',
    cancel_btn: 'Annuler',
    awaiting_mtedd: 'En attente d\'approbation MTEDD',
    queue_empty: 'La file d\'attente d\'approbation est vide',
    verified: 'Vérifié',
    audit_trail: 'Journal d\'Audit',
    audit_action: 'Action',
    audit_entity: 'Entité',
    audit_actor: 'Acteur',
    audit_timestamp: 'Horodatage',
    audit_details: 'Détails',
    audit_old_state: 'État Initial (Ancien)',
    audit_new_state: 'État Post-Action (Nouveau)',
    audit_empty: 'Le registre comptable est actuellement vide.',
    audit_error: 'Échec de la récupération des journaux sécurisés.',
    audit_standard: 'Norme d\'Audit Mondiale AIB',
    audit_desc: 'Ce Journal d\'Audit assure la conformité avec les Règles EECS Section I. Chaque transition du cycle de vie du certificat (Enregistrement → Émission → Transfert → Annulation) est enregistrée ici avec un hachage SHA-256.',
    close_entry: 'Fermer l\'entrée',
    compliance_reporting: 'Rapports de Conformité',
    compliance_reporting_desc: 'Extraits officiels du registre et déclarations de divulgation réglementaire pour la supervision internationale du domaine.',
    market_volume_report: 'Rapport de Volume du Marché',
    market_volume_desc: 'Résumé global des certificats émis, transférés et annulés dans le domaine.',
    account_statement: 'Relevé de Compte',
    account_statement_desc: 'Détail technique des avoirs du portefeuille de certificats et de l\'historique des transactions des participants.',
    disclosure_proof: 'Preuve de Divulgation',
    disclosure_proof_desc: 'Attestations d\'annulation conformes EECS pour les déclarations officielles d\'énergie verte.',
    custom_audit_manifest: 'Manifeste d\'Audit Personnalisé',
    custom_audit_desc: 'Initialiser l\'exportation de données brutes pour une inspection réglementaire autorisée.',
    init_wizard: 'Initialiser l\'Assistant',
    wizard_title: 'Assistant de Rapport Industriel',
    wizard_failed: 'Échec de la génération du rapport.',
    export_failed: 'Exportation industrielle échouée : délai d\'attente ou incompatibilité d\'autorisation.',
    download_pdf: 'Télécharger l\'extrait PDF',
    start_date: 'Date de début',
    end_date: 'Date de fin',
    generate_extract: 'Générer l\'extrait personnalisé',
    production_plants: 'Installations de Production',
    clear_sorts: 'Effacer les tris',
    refresh_grid: 'Actualiser la grille',
    register_device: 'Enregistrer un appareil de production',
    search_plants: 'Rechercher des installations...',
    dev_name: 'Nom',
    dev_locked: 'Verrouillé',
    dev_energy_source: 'Source d\'énergie',
    dev_technology: 'Technologie',
    dev_grid_ref: 'Référence réseau',
    dev_owner: 'Propriétaire / Déclarant',
    dev_active: 'Actif',
    national_grid: 'Réseau National',
    no_devices: 'Aucun appareil de production trouvé dans le domaine sélectionné.',
    of: 'sur',
    items: 'éléments',
    items_per_page: 'Éléments par page',
    transfers_ledger: 'Grand Livre des Transferts',
    months: 'Mois',
    start_transfer: 'Démarrer le transfert',
    market_liquidity: 'Liquidité du Marché',
    transactions: 'Transactions',
    transaction_id: 'ID de Transaction',
    recipient_entity: 'Entité Destinataire',
    domain_col: 'Domaine',
    eecs_hub_status: 'Statut Hub EECS',
    no_transactions: 'Aucun historique de transactions enregistré.',
    registry_participants: 'Participants au Registre',
    registry_participants_desc: 'Gestion du cycle de vie pour les Émetteurs & Négociants Internationaux',
    search_participants: 'Rechercher des participants...',
    new_entity: 'Nouvelle Entité',
    member_id: 'ID Membre',
    legal_name: 'Nom légal',
    classification: 'Classification',
    vat_id: 'Numéro TVA',
    operation_col: 'Opération',
    no_participants: 'Aucun participant trouvé',
    no_participants_desc: 'Aucun compte du registre ne correspond à votre recherche.',
    activate: 'Activer',
    vat_number: 'Numéro de TVA',
    legal_rep: 'Représentant légal',
    registry_id: 'ID du Registre',
    reg_country: 'Pays d\'enregistrement',
    confirm_approve: 'Vérifier et approuver ce titulaire de compte pour le trading GO international ?',
    approve_failed: 'Échec de l\'approbation du compte.',
    action_col: 'Type',
    entity_col: 'Entité',
    time_col: 'Date de soumission',
    wiki_back_to_portal: 'Retour au Portail',
    wiki_regulatory_cell: 'Cellule Réglementaire MTEDD'
  }
};

export function getLang() {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('lang') || 'fr';
  }
  return 'fr';
}

export function setLang(lang) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('lang', lang.toLowerCase());
    // Notify same-tab listeners (e.g. WikiHow) that the language changed
    window.dispatchEvent(new StorageEvent('storage', { key: 'lang', newValue: lang.toLowerCase() }));
  }
}

export function t(key) {
  const lang = getLang();
  return (translations[lang] && translations[lang][key]) || translations['en'][key] || key;
}

const i18n = { t, getLang, setLang };
export default i18n;
